import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet framework
import { devConfig, profile } from 'config/config'; // Importing configuration settings from config module

/**
 * Represents a view for the third table of providers.
 * @extends JetView
 */
export default class tableProvidersThirdView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            // Define a Webix datatable view
            view: 'datatable',
            // Unique identifier for the datatable
            id: 'datatable',
            // CSS classes for styling the datatable
            css: 'webix_header_border webix_data_border webix_footer_border',
            // Enable row selection
            select: true,
            // Conditional vertical scrolling based on screen width
            scrollY: screen.width < 820 ? false : true,
            // Set height based on screen width
            height: screen.width < 820 ? 410 : 0,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for editing with an icon
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip for the edit icon
                    tooltip: _('Editar'),
                    // Template function to render the edit icon based on permissions
                    template: function (obj) {
                        if (devConfig.getPermAction('accountingProvidersEdit', 'Edit')) {
                            return "<span class='webix_icon wxi-close edit'></span>";
                        } else {
                            return '';
                        }
                    },
                },
                // Column for ID with sorting enabled
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                // Column for Name with localization support
                { id: 'Name', header: _('Nombre'), width: 250, sort: 'int' },
                // Column for Email with localization support
                { id: 'Email', header: _('Email'), width: 250, sort: 'int' },
                // Column for Partner with localization support
                {
                    id: 'Partner',
                    header: _('Partner'),
                    width: 250,
                    sort: 'int',
                },
                // Column for Country, visibility controlled by permissions
                {
                    id: 'Country',
                    header: _('País'),
                    hidden: !devConfig.getPermAction('filterByCountry', 'Add'),
                    css: 'prm-filterByCountry',
                    width: 250,
                    sort: 'int',
                },
                // Column for RUC - NIT with localization support
                { id: 'Nit', header: _('RUC - NIT'), width: 250, sort: 'int' },
                // Column for State with a combo editor for selection
                {
                    id: 'State',
                    header: _('Estado'),
                    editor: 'combo',
                    // Options for the state selection
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 100,
                    sort: 'int',
                },
            ],
            // Event handler for click events on the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Show the edit form for providers
                    $$('EditProvidersThird').show();
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching strategy
            loadahead: devConfig.getDefaultDataFetch(),
            // Identifier for the pager component
            pager: 'pagerA',
            // URL for fetching data from the API
            url: devConfig.geturlApi() + 'Accounting/GetProvidersThird',
            // Event handlers for loading states
            on: {
                // Show overlay before data is loaded
                onBeforeLoad: function () {
                    this.showOverlay(
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    );
                },
                // Hide overlay after data is loaded
                onAfterLoad: function () {
                    this.hideOverlay();
                },
            },
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Get the URL for the grid data
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Create a modal window for editing provider information
        var popup = webix.ui({
            view: 'window',
            id: 'EditProvidersThird',
            head: {
                view: 'toolbar',
                cols: [
                    // Label for the window title
                    { view: 'label', label: _('Editar Proveedor') },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        // Close the window when the icon is clicked
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            // Center the window on the screen
            position: 'center',
            // Make the window modal
            modal: true,
            body: {
                view: 'form',
                id: 'editForm',
                elements: [
                    // Read-only field for the provider ID
                    { view: 'text', label: 'ID', name: 'Id', readonly: true },
                    // Input field for the provider's name
                    { view: 'text', label: _('Nombre'), name: 'Name' },
                    {
                        // Input field for the provider's email
                        view: 'text',
                        label: _('Email'),
                        name: 'Email',
                    },
                    {
                        // Combo box for selecting the partner
                        view: 'combo',
                        label: _('Partner'),
                        name: 'Partner',
                        readonly: true,
                        options: profile.Partners,
                    },
                    {
                        // Combo box for selecting the country
                        view: 'combo',
                        label: _('País'),
                        name: 'Country',
                        id: 'CountrySelect',
                        localId: 'CountrySelect',
                        readonly: true,
                        options: profile.Partners[0].Countries,
                    },
                    {
                        // Input field for the RUC/NIT
                        view: 'text',
                        label: _('RUC - NIT'),
                        name: 'Nit',
                    },
                    {
                        // Combo box for selecting the state
                        view: 'combo',
                        label: _('Estado'),
                        name: 'State',
                        options: [
                            { id: 'A', value: _('Activado') },
                            { id: 'I', value: _('Inactivado') },
                        ],
                    },
                    {
                        // Container for buttons
                        cols: [
                            {
                                // Cancel button
                                view: 'button',
                                value: _('Cancelar'),
                                // Close the window and reset the form values
                                click: function () {
                                    this.getTopParentView().hide();
                                   $$('editForm').setValues($$('editForm').getCleanValues());
                                },
                            },
                            {
                                // Save button
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'),
                                // Handle the save action
                                click: function ($e) {
                                    // Get the values from the form
                                    var values =$$('editForm').getValues();
                                    // Send an AJAX POST request to save the provider data
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Accounting/SaveProvidersThird',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "Nit":"' +
                                                values.Nit +
                                                '", "State":"' +
                                                values.State +
                                                '", "Email":"' +
                                                values.Email +
                                                '", "Partner":"' +
                                                values.Partner +
                                                '", "Country":"' +
                                                values.Country +
                                                '"}',
                                            {
                                                // Handle error response
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! '));
                                                },
                                                // Handle success response
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Proveedor Actualizado'));
                                                    // Clear the grid data
                                                    grid.clearAll();
                                                    // Reload the grid with updated data
                                                    grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter);
                                                },
                                            },
                                        );
                                    // Reset the form values after saving
                                   $$('editForm').setValues($$('editForm').getCleanValues());
                                    // Close the window after saving
                                    this.getTopParentView().hide();
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Bind the edit form to the data table for data synchronization
       $$('editForm').bind($$('datatable'));

        // Create a popup window for adding new providers
        var popupAdd = webix.ui({
            view: 'window', // Define the view type as a window
            id: 'AddProvidersThird', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Añadir Proveedor') }, // Label for the window title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close',
                        click: function () {
                            // Hide the window when the close icon is clicked
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Define the body as a form
                id: 'addformProvider', // Unique identifier for the form
                elements: [
                    { view: 'text', label: _('Nombre'), name: 'Name' }, // Input for provider name
                    {
                        view: 'text',
                        label: _('Email'), // Input for provider email
                        name: 'Email',
                    },
                    {
                        view: 'combo', // Dropdown for selecting a partner
                        label: _('Partner'),
                        name: 'Partner',
                        value: profile.Partners[0].id, // Default value set to the first partner's ID
                        options: profile.Partners, // Options populated from the profile
                        on: {
                            onChange(newVal, oldVal) {
                                // Event triggered when the partner selection changes
                                var list = $$('CountrySelect').getPopup().getList(); // Get the list of countries
                                var new_options = [
                                    { id: 1, name: 'Germany' },
                                    { id: 2, name: 'Great Britain' },
                                ];
                                // Iterate through partners to find the selected one
                                profile.Partners.forEach(function (obj) {
                                    if (obj.id == newVal) {
                                        console.log(obj); // Log the selected partner object
                                        console.log(newVal); // Log the new value
                                        console.log(obj.Countries); // Log the countries of the selected partner
                                        list.clearAll(); // Clear the current country options
                                        list.parse(obj.Countries); // Populate the country options based on the selected partner
                                        $$('CountrySelect').setValue(''); // Reset the country selection
                                    }
                                });
                            },
                        },
                    },
                    {
                        view: 'combo', // Dropdown for selecting a country
                        label: _('País'),
                        name: 'Country',
                        id: 'CountrySelect', // Unique identifier for the country select
                        localId: 'CountrySelect', // Local identifier for the country select
                        value: profile.Partners[0].Countries[0].id, // Default value set to the first country's ID
                        options: profile.Partners[0].Countries, // Options populated from the first partner's countries
                    },
                    {
                        view: 'text', // Input for RUC - NIT
                        label: _('RUC - NIT'),
                        name: 'Nit',
                    },
                    {
                        view: 'combo', // Dropdown for selecting the state
                        label: _('Estado'),
                        name: 'State',
                        options: [
                            { id: 'A', value: _('Activado') }, // Option for activated state
                            { id: 'I', value: _('Inactivado') }, // Option for deactivated state
                        ],
                    },
                    {
                        cols: [
                            // Define a row of buttons
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    // Hide the window and reset the form values when canceled
                                    this.getTopParentView().hide();
                                    $$('addformProvider').setValues($$('addformProvider').getCleanValues());
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    // Get form values for submission
                                    var values = $$('addformProvider').getValues();
                                    webix
                                        .ajax() // Perform an AJAX request to save the provider
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Accounting/SaveProvidersThird',
                                            '{"Name":"' +
                                                values.Name +
                                                '", "Nit":"' +
                                                values.Nit +
                                                '", "State":"' +
                                                values.State +
                                                '", "Email":"' +
                                                values.Email +
                                                '", "Partner":"' +
                                                values.Partner +
                                                '", "Country":"' +
                                                values.Country +
                                                '"}', // Send the provider data as JSON
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Handle error response
                                                    webix.message(_('Error! '));
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Handle successful response
                                                    webix.message(_('Proveedor Agregado')); // Notify user of successful addition
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload the grid with updated data
                                                    );
                                                },
                                            },
                                        );
                                    $$('addformProvider').setValues(
                                        $$('addformProvider').getCleanValues(), // Reset form values after submission
                                    );
                                    this.getTopParentView().hide(); // Hide the window after submission
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Listen for the 'providersThird:filter' event on the app instance
        this.on(this.app, 'providersThird:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize an empty string to build query parameters

            // Iterate over each key-value pair in the object
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle 'CreatedLocalDate' specifically
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split the date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        // Handle 'ModifiedLocalDate' specifically
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split the date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add start date to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add end date to query
                        } else {
                            // For other key-value pairs, append them to the query string
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    // If the value is an object, process its entries
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' key for dateFrom
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create a Date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) + // Format month
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) + // Format day
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) + // Format hours
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) + // Format minutes
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format seconds
                                    string1 = string1 + '&' + dateFrom; // Append to query string
                                } else {
                                    // Handle 'end' key for dateTo
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create a Date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) + // Format month
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) + // Format day
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) + // Format hours
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) + // Format minutes
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format seconds
                                        string1 = string1 + '&' + dateTo; // Append to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid before loading new data
            // Load data into the grid with constructed query parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event listener for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters and pagination
            grid.load(
                url + // Base URL for loading data
                    '?start=0&count=' + // Pagination parameters
                    grid.data.$pagesize + // Current page size from grid data
                    filter + // Additional filter parameters
                    '&sort[' + // Sorting parameters
                    by + // Column to sort by
                    ']=' +
                    dir, // Direction of sorting (ascending/descending)
            );
        });

        // Listen for the 'addProvidersThird:button' event on the app instance
        this.on(this.app, 'addProvidersThird:button', (filter) => {
            // Show the popup for adding providers
            popupAdd.show();
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
